<template>
    <div class="animated fadeIn">

        <b-card :no-body="true" footer-class="px-3 py-2">
            <b-card-body class="p-3 clearfix">
                <i :class="iconClass"></i>
                <div :class="textClass"><b-spinner small v-if="loading" /> <span v-else> {{count}}</span></div>
                <div class="text-muted text-uppercase font-weight-bold font-xs">{{title}}</div>
                <div class="text-muted font-xs"> <b-spinner small v-if="loadingAmount" /> <span v-else> {{formatter.format(amount)}} </span></div>
            </b-card-body>
            <div slot="footer">
                <b-link class="font-weight-bold font-xs btn-block text-muted" :to="toRoute">Mai multe detalii... <i class="fa fa-angle-right float-right font-lg"></i></b-link>
            </div>
        </b-card>

    </div>
</template>
<script>
    import { widgetsService } from '../../services/WidgetsService';
    export default {
        name: 'OnlineErrorsCount',

        components: {

        },
        props: {

            IsSiteOrder: {
                type: Boolean,
                default: false,

            }

        },
        data: () => {
            return {
                loading: true,
                loadingAmount: false,
                count: 0,
                amount: 0,
                title: '',
                value: 0,
                toRoute: {
                    name: '',
                    params: null,
                },
                iconClass: '',
                textClass: '',
                formatter: new Intl.NumberFormat('ro-RO', {
                    style: 'currency',
                    currency: 'RON',
                })

            }
        },
        created() {
            var model = this;
            var searchOrderParams = {
                EndDate: null,//new Date(),
                StartDate: null,//new Date(),
                OrderType: 0,
                Status: [2], // confirmed
                InsuranceCompanies: [],
                UserId: '',
                FilterType: 1, // custom filter
                RequestStatus: -1, // All request statuses
                IsSiteOrder: this.IsSiteOrder,
                CreatedMinAgo: 15,
            }

            this.title = 'Comenzi cu erori'
            this.iconClass = 'fa fa-close bg-secondary p-3 font-2xl mr-3 float-left ';
            this.textClass = 'h5 text-secondary mb-0 mt-0'

            searchOrderParams.StartDate = new Date();
            searchOrderParams.EndDate = new Date();

            this.loading = true;
            widgetsService.getCount(searchOrderParams, '').then((response) => {
                this.count = response.data;
                this.loading = false;

                if (this.count > 0) {
                    this.iconClass = 'fa fa-close bg-danger p-3 font-2xl mr-3 float-left flashit';
                    this.textClass = 'h5 text-danger mb-0 mt-0'

                    model.loadingAmount = true;
                    widgetsService.getTotalAmount(searchOrderParams, '').then((resp) => {
                        model.amount = resp.data;
                        model.loadingAmount = false;
                    });
                }
            });

            this.toRoute = {
                name: 'ConfirmedOrderList',
                params: {
                    filter: searchOrderParams,
                }
            }

        },
        methods: {


        },

    }
</script>
